/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Change, ChangeData } from './change.model';
// import { forEach } from '../helper/for-each.helper';

export interface ChangedEventData {
  source: any;
  changes: { [key: string]: ChangeData<any> };
  originalEvent?: ChangedEventData;
}

export class ChangedEvent implements ChangedEventData {
  public readonly source: any;
  public readonly changes: { [key: string]: Change<any> };
  public readonly originalEvent: ChangedEvent;

  constructor(data: ChangedEventData) {
    this.source = data.source;
    this.changes = {};
    if (data.changes) {
      for (const key in data.changes) {
        if (!data.changes.hasOwnProperty(key)) {
          continue;
        }
        const modificationData = data.changes[key];
        this.changes[key] = modificationData instanceof Change
          ? modificationData as Change<any>
          : new Change(modificationData);
      }
    }
    if (data.originalEvent) {
      this.originalEvent = data.originalEvent instanceof ChangedEvent
        ? data.originalEvent as ChangedEvent
        : new ChangedEvent(data.originalEvent);
    } else {
      this.originalEvent = this;
    }
  }

  toJSON(): object {
    const changes = {};
    Object.keys(this.changes).forEach((key) => changes[key] = this.changes[key].toJSON());
    return {
      source: typeof this.source.toJSON === 'function' ? this.source.toJSON() : this.source,
      changes,
      originalEvent: this.originalEvent !== this ? this.originalEvent.toJSON() : null
    };
  }

}
